'use strict';

const defaultModelPartial = require('./model/model.default');
const lastChanceModelActions = require('./model/model.actions');

module.exports = Backbone.Model.extend(Odigeo._.extend(defaultModelPartial, lastChanceModelActions, {
    connect: true,
    selectors: [
        'primeMemberSelected',
        'existsEvolviCarrier',
        'existsDeutscheBahnCarrier',
        'userStatus',
    ],
}));
